"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get APPOINTMENT_CANCELLATION_REASON_LABELS () {
        return APPOINTMENT_CANCELLATION_REASON_LABELS;
    },
    get AppointmentCancellationItemSchema () {
        return AppointmentCancellationItemSchema;
    },
    get AppointmentCancellationReasonSchema () {
        return AppointmentCancellationReasonSchema;
    },
    get AppointmentCancellationSchema () {
        return AppointmentCancellationSchema;
    }
});
const _zod = require("zod");
const _optionaltrimmedtext = require("./optional-trimmed-text");
const AppointmentCancellationReasonSchema = _zod.z.enum([
    'patient_request',
    'provider_unavailable',
    'clinic_closed',
    'booked_in_error',
    'other'
]);
const APPOINTMENT_CANCELLATION_REASON_LABELS = {
    patient_request: 'Patient request',
    provider_unavailable: 'Doctor unavailable',
    clinic_closed: 'Clinic closed',
    booked_in_error: 'Booked in error',
    other: 'Other'
};
const AppointmentCancellationSchema = _zod.z.object({
    reasonCode: AppointmentCancellationReasonSchema,
    note: (0, _optionaltrimmedtext.optionalTrimmedText)(120)
}).strict();
const AppointmentCancellationItemSchema = _zod.z.object({
    reasonCode: AppointmentCancellationReasonSchema,
    note: _zod.z.string().nullable()
});
